import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.pages.CustomizePurchaseOrderFormPage`

export default defineMessages({
  settingsTitle: {
    id: `${scope}.settingsTitle`,
    defaultMessage: 'Settings',
  },
  customizePurchaseOrderFormTitle: {
    id: `${scope}.customizePurchaseOrderFormTitle`,
    defaultMessage: 'Customize purchase order form',
  },
  moduleLoading: {
    id: `${scope}.moduleLoading`,
    defaultMessage: 'Module loading...',
  },
})
